/**
 * Trạng thái hoạt động
 * nddat1 30/01/2023
 */
export default {
  NotValid: 0,
  Valid: 1
};